export default "__VITE_ASSET__B$bx7DeS__"